import { Bot, ChevronDown, FolderKanban, MessageSquare, MoreHorizontal, Plus, Trash2 } from "lucide-react";
import type { ChatSession, Project } from "../types";

export function Sidebar({ projects, chats, projectId, chatId, onSelectProject, onSelectChat, onNewChat, onNewProject, onDeleteChat }: {
  projects: Project[]; chats: ChatSession[]; projectId: string | null; chatId: string | null;
  onSelectProject: (id: string) => void; onSelectChat: (id: string) => void; onNewChat: () => void; onNewProject: () => void; onDeleteChat: (id: string) => void;
}) {
  return (
    <aside className="sidebar">
      <div className="brand"><span className="brand-mark"><Bot size={17} /></span><strong>alloia.pro</strong></div>
      <button className="new-task-button" onClick={onNewChat}><Plus size={16} /> Nouvelle tâche</button>
      <div className="sidebar-section-title"><span>Conversations</span></div>
      <nav className="chat-list" aria-label="Conversations">
        {chats.length === 0 && <p className="sidebar-empty">Aucune conversation</p>}
        {chats.map((chat) => (
          <div className={`sidebar-row ${chat.id === chatId ? "active" : ""}`} key={chat.id}>
            <button className="sidebar-row-main" onClick={() => onSelectChat(chat.id)} title={chat.title}>
              <MessageSquare size={14} /><span>{chat.title}</span>
            </button>
            <button className="row-action" onClick={() => onDeleteChat(chat.id)} aria-label={`Supprimer ${chat.title}`}><Trash2 size={13} /></button>
          </div>
        ))}
      </nav>
      <div className="project-section">
        <div className="sidebar-section-title"><span>Projets</span><button className="row-action always" onClick={onNewProject} aria-label="Nouveau projet"><Plus size={14} /></button></div>
        <div className="project-list">
          {projects.map((project) => (
            <button key={project.id} className={`project-row ${project.id === projectId ? "active" : ""}`} onClick={() => onSelectProject(project.id)}>
              <FolderKanban size={14} /><span>{project.name}</span>{project.id === projectId && <ChevronDown size={13} />}
            </button>
          ))}
        </div>
      </div>
      <div className="sidebar-footer"><span>Local-first</span><MoreHorizontal size={15} /></div>
    </aside>
  );
}
